export default __webpack_public_path__ + "static/media/solomon.e83ec75a.jpg";